import { getComponentName } from '../../helpers/componentHelpers';
import { createCssVarImageClass } from '../../baseClasses/createCssVarImageClass';

export const componentName = getComponentName('totp-image');

export const TotpImageClass = createCssVarImageClass({
  componentName,
  varName: 'url',
  fallbackVarName: 'fallbackUrl',
});
